<ng-container *ngIf="payment$ | async as payment">
    <ng-container *ngIf="payment&&payment.plan&&payment.plan.includes('daytime')">
      <svg-icon key="daytime" [fontSize]="icon_size+'px'" class="ml-1.5" nz-tooltip nzTooltipTitle="Daytime plan"></svg-icon>
    </ng-container>
  </ng-container>

